import './css/index.css';
import React, { useEffect, createRef } from 'react';
import { min, max } from 'd3-array';
import { select, selectAll, selection } from 'd3-selection';
import { sliderBottom } from 'd3-simple-slider';
import { func, number } from 'prop-types';

const LineThickness = ( props ) => {

    const sliderRef = createRef();
    const width = 110;

    selection.prototype.patternify = function ( params ) {

        const container = this;
        const selector = params.selector;
        const elementTag = params.tag;
        const data = params.data || [ selector ];

        // Pattern in action
        let selection = container.selectAll( `.${ selector }` ).data( data, ( d, i ) => {

            if ( typeof d === 'object' ) {

                if ( d.id ) {

                    return d.id;

                }

            }

            return i;

        } );


        selection.exit().remove();
        selection = selection.enter().append( elementTag )
            .merge( selection );
        selection.attr( 'class', selector );

        return selection;

    };

    useEffect( () => {

        const data = [ 2, 5 ];
        const slider = sliderBottom()
            .min( min( data ) )
            .max( max( data ) )
            .width( width )
            .tickValues( data )
            .ticks( 4 )
            .tickFormat( ( x ) => `${ x }px` )
            .step( 0.50 )
            .default( props.defaultThicknessValue )
            .displayValue( false )
            .on( 'onchange', ( val ) => {

                props.updateThickness( val );

            } );

        const g = select( sliderRef.current )
            .append( 'g' )
            .attr( 'transform', 'translate(10,20)' );

        g.call( slider );

        // remove default track before replacing
        select( '.track' ).remove();
        select( '.track-inset' ).remove();
        select( '.track-overlay' ).remove();

        // remove bottom axis labels
        selectAll( '.axis' ).remove();

        select( ' .slider' )
            .append( 'polygon' )
            .attr( 'stroke', '#011e4d' )
            .attr( 'points', `-5,0, 132,3.5, 132,-3.5` )
            .attr( 'shape-rendering', 'geometricPrecision' )
            .style( 'fill', '#011e4d' )
            .raise();

        select( '.handle' )
            .attr( 'd', 'M 0 0 a 8,8 0 1,1 16,0 a 8,8 0 1,1 -16,0' );

        // reorder circle to be on top
        select ( '.parameter-value' ).raise();

    }, [] );

    return (
        <>
            <div className='slider-wrapper'>

                <div>Line Thickness</div>
                <svg ref={ sliderRef } width={ width + 50 } height={ 40 } ></svg>

            </div>
        </>
    );

};

LineThickness.propTypes = {
    updateThickness: func.isRequired,
    defaultThicknessValue: number.isRequired
};

export default LineThickness;